import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getAtm = (atmId: number | undefined): Promise<IGetAtmViaID> => {
  return axiosDefaultApi.get(`/api/Atm/GetAtmViaID/${atmId}`);
};

type QueryFnType = typeof getAtm;

type UseGetAtmOptions = {
  atmId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAtm = ({ atmId , config }: UseGetAtmOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getAtm_${atmId}`],
    queryFn: () => getAtm(atmId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση του ΑΤΜ.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};